<template>
    <div class="relative flex flex-col items-center justify-center p-4 pt-3 mb-10 overflow-hidden border-4 border-gray-200 border-dashed rounded-wl md:p-6 lg:p-8 md:pt-5 lg:pt-6">
      <slot name="default"></slot>
    </div>
</template>
